import * as Events from "./AliceGPTContextEvents";
import { removeAttributeWithOtherEntityName } from "./utils";

const enabledPageConfigurationFields = [
    "shouldCreateTable",
    "shouldCreateSplitView",
    "shouldCreateKanban",
    "shouldCreateCards",
    "shouldCreateCalendar",
    "shouldCreateGanttChart"
];

export default (state, action) => {
    switch (action.type) {
        case Events.NEXT:
            return {
                ...state,
                step: state.step + 1
            };
        case Events.BACK:
            return {
                ...state,
                step: state.step - 1,
                relationsLoaded: state.step === 2 ? state.relations && state.relations.length > 0 : state.relationsLoaded
            };
        case Events.SUBSCRIPTION_LOADED:
            return {
                ...state,
                subscription: action.payload
            }
        case Events.FORM_UPDATED:
            return {
                ...state,
                form: action.payload,
                formUpdated: true,
                isLoadingEntities: true,
                entities: [],
                relations: []
            };
        case Events.SHOW_ADVANCED_CONFIGURATIONS:
            return {
                ...state,
                showAdvancedConfigurations: true
            };
        case Events.HIDE_ADVANCED_CONFIGURATIONS:
            return {
                ...state,
                showAdvancedConfigurations: false
            };
        case Events.ENTITIES_LOADED:
            const entssities = action.payload;
            debugger;
            return {
                ...state,
                isLoadingEntities: false,
                entities: action.payload.map(entity => ({
                    ...entity,
                    pageConfiguration: {
                        shouldCreateTable: true,
                        shouldCreateSplitView: true,
                        shouldCreateKanban: false,
                        shouldCreateCards: false,
                        shouldCreateCalendar: false,
                        shouldCreateGanttChart: false,
                        shouldCreateDetailsView: true,
                        shouldCreateEditRecord: true,
                        shouldCreateNewRecord: !entity.isUserEntity,
                        isKanbanDisabled: entity.isUserEntity,
                        isCalendarDisabled: entity.isUserEntity,
                        isGanttChartDisabled: entity.isUserEntity
                    }
                })),
                selectedEntity: action.payload.length > 0 ? action.payload[0] : state.selectedEntity,
                namesOfSelectedEntities: action.payload.length > 0 ? action.payload.filter(entity => entity.checked).map(entity => entity.name) : [],
                formUpdated: false
            };
        case Events.ENTITIES_ADDED:
            const filteredNewEntities = action.payload.filter(entity => (
                !state.entities.some(e => e.name === entity.name)
            ));
            const entities = [
                ...state.entities,
                ...filteredNewEntities.map(entity => ({
                    ...entity,
                    attributes: [],
                    pageConfiguration: {
                        shouldCreateTable: true,
                        shouldCreateSplitView: true,
                        shouldCreateKanban: false,
                        shouldCreateCards: false,
                        shouldCreateCalendar: false,
                        shouldCreateGanttChart: false,
                        shouldCreateDetailsView: true,
                        shouldCreateEditRecord: true,
                        shouldCreateNewRecord: true,
                        isKanbanDisabled: entity.isUserEntity,
                        isCalendarDisabled: entity.isUserEntity,
                        isGanttChartDisabled: entity.isUserEntity
                    }
                }))
            ]
            return {
                ...state,
                entities: entities
            };
        case Events.ENTITY_SELECTED:
            return {
                ...state,
                selectedEntity: action.payload
            };
        case Events.ENTITY_DESELECTED:
            return {
                ...state,
                selectedEntity: null
            };
        case Events.ENTITY_UPDATED:
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.id === action.payload.id) {
                        return action.payload;
                    }
                    return entity;
                })
            };
        case Events.ENTITY_CHECKED: {
            const newEntities = state.entities.map((entity, index) => {
                if (index === action.payload.entityIndex) {
                    return {
                        ...entity,
                        checked: true,
                        attributes: entity.attributes ? entity.attributes.map((attribute, attributeIndex) => ({
                            ...attribute,
                            selected: attributeIndex < 10
                        })) : []
                    }
                }
                return entity;
            })
            const numSelectedEntities = newEntities.filter(entity => entity.checked).length;
            return {
                ...state,
                entities: newEntities,
                namesOfSelectedEntities: [
                    ...state.namesOfSelectedEntities,
                    state.entities[action.payload.entityIndex].name
                ],
                selectedEntity: {
                    ...state.selectedEntity,
                    checked: true,
                    attributes: state.selectedEntity.name === state.entities[action.payload.entityIndex].name ?
                        state.selectedEntity.attributes.map((attribute, attributeIndex) => ({
                            ...attribute,
                            selected: attributeIndex < 10
                        })) : state.selectedEntity.attributes
                },
                relations: numSelectedEntities < 3 ? [] : state.relations,
                initialAttributesLoaded: false,
                relationsLoaded: false
            };
        }
        case Events.ENTITY_UNCHECKED: {
            debugger;
            const newEntities = state.entities.map((entity, index) => {
                if (index === action.payload.entityIndex) {
                    return {
                        ...entity,
                        checked: false,
                        attributes: entity.attributes.map(attribute => ({
                            ...attribute,
                            selected: false
                        }))
                    }
                }
                return entity;
            })
            const numSelectedEntities = newEntities.filter(entity => entity.checked).length;
            return {
                ...state,
                entities: newEntities,
                namesOfSelectedEntities: state.namesOfSelectedEntities.filter(name => (
                    name !== state.entities[action.payload.entityIndex].name
                )),
                selectedEntity: {
                    ...state.selectedEntity,
                    checked: false,
                    attributes: state.selectedEntity.name === state.entities[action.payload.entityIndex].name ?
                        state.selectedEntity.attributes.map(attribute => {
                            return {
                                ...attribute,
                                selected: false
                            }
                        }) : state.selectedEntity.attributes
                },
                relations: numSelectedEntities < 3 ? [] : state.relations,
                initialAttributesLoaded: false,
                relationsLoaded: false
            };
        }
        case Events.TOGGLE_SELECT_ALL_ENTITIES:
            const everyEntityChecked = state.entities.every(entity => entity.checked);
            const val = {
                ...state,
                entities: state.entities.map(entity => ({
                    ...entity,
                    checked: entity.isStatic ? true : !everyEntityChecked,
                    attributes: entity.attributes ? entity.attributes.map((attribute, attributeIndex) => ({
                        ...attribute,
                        selected: attribute.isAzureAttribute ? true : (!everyEntityChecked && attributeIndex < 10)
                    })) : []
                })),
                namesOfSelectedEntities: everyEntityChecked ? [] : state.entities.map(entity => entity.name),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributes: state.selectedEntity.attributes.map((attribute, attributeIndex) => ({
                        ...attribute,
                        selected: attribute.isAzureAttribute ? true : (!everyEntityChecked && attributeIndex < 10)
                    }))
                },
                relations: everyEntityChecked && state.entities.length < 3 ? [] : state.relations,
                initialAttributesLoaded: false,
                relationsLoaded: false
            };
            return val;
        case Events.TOGGLE_ENTITY_EDIT:
            return {
                ...state,
                entities: state.entities.map((entity, index) => {
                    if (index === action.payload.entityIndex) {
                        debugger
                        return {
                            ...entity,
                            inEdit: !entity.inEdit
                        }
                    }
                    return entity;
                })
            }
        case Events.ENTITY_NAME_CHANGED:
            return {
                ...state,
                entities: state.entities.map((entity, index) => {
                    if (index === action.payload.entityIndex) {
                        return {
                            ...entity,
                            name: action.payload.newEntityName.trim(),
                        };
                    }
                    return entity;
                }),
                relations: state.relations && state.relations.length > 0 ? state.relations.map(relation => {
                    if (relation.from === state.entities[action.payload.entityIndex].name) {
                        return {
                            ...relation,
                            from: action.payload.newEntityName.trim()
                        }
                    }
                    if (relation.to === state.entities[action.payload.entityIndex].name) {
                        return {
                            ...relation,
                            to: action.payload.newEntityName.trim()
                        }
                    }
                    return relation;
                }) : state.relations
            }
        case Events.RESET_RELATIONS_LOADED:
            return {
                ...state,
                relations: [],
                initialAttributesLoaded: true,
                relationsLoaded: false
            }
        case Events.RELATIONS_LOADED:
            return {
                ...state,
                relations: action.payload,
                initialAttributesLoaded: true,
                relationsLoaded: true
            };
        case Events.RELATION_SELECTED:
            return {
                ...state,
                relations: state.relations.map((relation, index) => {
                    if (index === action.payload.relationIndex) {
                        return {
                            ...relation,
                            selected: true
                        }
                    }
                    return relation;
                })
            };
        case Events.RELATION_DESELECTED:
            return {
                ...state,
                relations: state.relations.map((relation, index) => {
                    if (index === action.payload.relationIndex) {
                        return {
                            ...relation,
                            selected: false,
                            showReferenceAttribute: false
                        }
                    }
                    return relation;
                })
            };
        case Events.SHOW_REFERENCE_ATTRIBUTE_TOGGLED:
            return {
                ...state,
                relations: state.relations.map((relation, index) => {
                    if (index === action.payload.relationIndex) {
                        return {
                            ...relation,
                            selected: !relation.showReferenceAttribute && !relation.selected ? true : relation.selected,
                            showReferenceAttribute: !relation.showReferenceAttribute
                        }
                    }
                    return relation;
                })
            };
        case Events.REFERENCE_ATTRIBUTE_CHANGED:
            return {
                ...state,
                relations: state.relations.map((relation, index) => {
                    if (index === action.payload.relationIndex) {
                        return {
                            ...relation,
                            referenceAttribute: action.payload.referenceAttribute
                        }
                    }
                    return relation;
                })
            };
        case Events.INITIAL_REFERENCE_ATTRIBUTES_LOADED:
            return {
                ...state,
                initialAttributesLoaded: true
            }
        case Events.ATTRIBUTES_LOADED: {
            const entityNames = state.entities.map(entity => entity.name).filter(name => name !== action.payload.entityName);
            const attributes = removeAttributeWithOtherEntityName(action.payload.attributes, entityNames)
            const { shouldCheckEntity } = action.payload;
            const everyEntityChecked = state.entities.every(entity => entity.checked);
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributes: attributes.map((attribute, index) => {
                                if (attribute.type === "State Field") {
                                    const otherStateAttributeIndex = attributes.findIndex(attr => attr.type === "State Field" && attr.name !== attribute.name);
                                    // there is no other state attribute or this is the first state attribute
                                    const isSelected = otherStateAttributeIndex === -1 || index < otherStateAttributeIndex;
                                    return {
                                        ...attribute,
                                        selected: (entity.checked || everyEntityChecked) && shouldCheckEntity && entity.checked && isSelected && index < 10
                                    }
                                }
                                return {
                                    ...attribute,
                                    selected: (entity.checked || everyEntityChecked) && shouldCheckEntity && entity.checked && index < 10
                                }
                            }),
                            attributesLoading: false,
                            disabled: attributes.length === 0,
                            checked: (entity.checked || everyEntityChecked) && shouldCheckEntity && attributes.length > 0,
                            hasAttributeLoadingError: false
                        }
                    }
                    return entity;
                }),
                selectedEntity: state.selectedEntity.name === action.payload.entityName ?
                    {
                        ...state.selectedEntity,
                        attributes: attributes.map((attribute, index) => {
                            if (attribute.type === "State") {
                                const otherStateAttributeIndex = attributes.findIndex(attr => attr.type === "State" && attr.name !== attribute.name);
                                // there is no other state attribute or this is the first state attribute
                                const isSelected = otherStateAttributeIndex === -1 || index < otherStateAttributeIndex;
                                return {
                                    ...attribute,
                                    selected: (state.selectedEntity.checked || everyEntityChecked) && shouldCheckEntity && state.selectedEntity.checked && isSelected && index < 10
                                }
                            }
                            return {
                                ...attribute,
                                selected: (state.selectedEntity.checked || everyEntityChecked) && shouldCheckEntity && state.selectedEntity.checked && index < 10
                            }
                        }),
                        disabled: attributes.length === 0,
                        checked: (state.selectedEntity.checked || everyEntityChecked) && shouldCheckEntity && attributes.length > 0,
                        attributesLoading: false,
                        hasAttributeLoadingError: false
                    }
                    :
                    state.selectedEntity
            };
        }
        case Events.ATTRIBUTE_SELECTED: {
            const newNamesOfSelectedEntities = state.namesOfSelectedEntities.includes(action.payload.entityName) ? state.namesOfSelectedEntities : [
                ...state.namesOfSelectedEntities,
                action.payload.entityName
            ];
            const isNamesOfSelectedEntitiesChanged = newNamesOfSelectedEntities.length !== state.namesOfSelectedEntities.length || !newNamesOfSelectedEntities.every(name => state.namesOfSelectedEntities.includes(name));
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            checked: true,
                            attributes: entity.attributes.map((attribute, attributeIndex) => {
                                if (attributeIndex === action.payload.attributeIndex) {
                                    return {
                                        ...attribute,
                                        selected: true
                                    }
                                }
                                return attribute;
                            })
                        }
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributes:
                        state.selectedEntity.name === action.payload.entityName ?
                            state.selectedEntity.attributes.map((attribute, attributeIndex) => {
                                if (attributeIndex === action.payload.attributeIndex) {
                                    return {
                                        ...attribute,
                                        selected: true
                                    }
                                }
                                return attribute;
                            })
                            :
                            state.selectedEntity.attributes,
                    checked: true
                },
                namesOfSelectedEntities: newNamesOfSelectedEntities,
                relations: newNamesOfSelectedEntities.length < 3 ? [] : state.relations,
                relationsLoaded: newNamesOfSelectedEntities.length < 3 ? false : state.relationsLoaded,
                initialAttributesLoaded: newNamesOfSelectedEntities.length < 3 ? false : state.initialAttributesLoaded
            };
        }
        case Events.ATTRIBUTE_DESELECTED:
            const allSelectedAttributes = state.selectedEntity.attributes.filter(attr => attr.selected);
            const newAttributes = state.selectedEntity.attributes.map((attribute, attributeIndex) => {
                if (attributeIndex === action.payload.attributeIndex) {
                    return {
                        ...attribute,
                        selected: false
                    }
                }
                return attribute;
            });
            const newSelectedAttributes = newAttributes.filter(attribute => attribute.selected);
            const selectedTextAttributes = allSelectedAttributes
                .filter(attribute => attribute.type === "string")
                .filter(attribute => attribute.name !== action.payload.attributeName);
            const newNamesOfSelectedEntities = newSelectedAttributes.length === 0 ? state.namesOfSelectedEntities.filter(name => name !== action.payload.entityName) : state.namesOfSelectedEntities;
            const isNamesOfSelectedEntitiesChanged = newNamesOfSelectedEntities.length !== state.namesOfSelectedEntities.length || !newNamesOfSelectedEntities.every(name => state.namesOfSelectedEntities.includes(name));
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributes: newAttributes,
                            checked: allSelectedAttributes.length > 1
                        }
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributes:
                        state.selectedEntity.name === action.payload.entityName ?
                            newAttributes
                            :
                            state.selectedEntity.attributes,
                    checked: allSelectedAttributes.length > 1
                },
                relations: newNamesOfSelectedEntities.length < 3 ? [] : state.relations.map(relation => {
                    if (relation.showReferenceAttribute && relation.referenceAttribute === action.payload.attributeName) {
                        return {
                            ...relation,
                            showReferenceAttribute: selectedTextAttributes.length > 0,
                            referenceAttribute: (
                                selectedTextAttributes.length > 0 ? selectedTextAttributes[0].name : ""
                            )
                        }
                    }
                    return relation;
                }),
                namesOfSelectedEntities: newNamesOfSelectedEntities,
                relationsLoaded: newNamesOfSelectedEntities.length < 3 ? false : state.relationsLoaded,
                initialAttributesLoaded: newNamesOfSelectedEntities.length < 3 ? false : state.initialAttributesLoaded
            };
        case Events.ATTRIBUTES_ADDED: {
            const entityNames = state.entities.map(entity => entity.name).filter(name => name !== action.payload.entityName);
            const attributes = removeAttributeWithOtherEntityName(action.payload.attributes, entityNames)
            const selectedEntity = { ...state.selectedEntity };
            if (selectedEntity.name === action.payload.entityName) {
                const newAttributes = attributes.filter(attribute => (
                    !selectedEntity.attributes.some(a => a.name === attribute.name)
                ));
                selectedEntity.attributes = [
                    ...selectedEntity.attributes,
                    ...newAttributes
                ];
                selectedEntity.hadNoMoreAttributes = newAttributes.length === 0;
                selectedEntity.disabled = selectedEntity.isStatic ? true : selectedEntity.attributes.length === 0;
            }
            const entities = state.entities.map(entity => {
                if (entity.name === action.payload.entityName) {
                    const newAttributes = attributes.filter(attribute => (
                        !entity.attributes.some(a => a.name === attribute.name)
                    ));
                    const allAttributes = [
                        ...entity.attributes,
                        ...newAttributes
                    ];
                    return {
                        ...entity,
                        attributes: allAttributes,
                        hadNoMoreAttributes: newAttributes.length === 0,
                        disabled: entity.isStatic ? true : allAttributes.length === 0
                    }
                }
                return entity;
            });
            return {
                ...state,
                entities, selectedEntity
            };
        }
        case Events.ATTRIBUTE_PICKLIST_UPDATED:
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        entity.attributes = entity.attributes.map(attribute => {
                            if (attribute.name === action.payload.attributeName) {
                                attribute.picklist = action.payload.picklist;
                            }
                            return attribute;
                        });
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributes:
                        state.selectedEntity.name === action.payload.entityName ?
                            state.selectedEntity.attributes.map(attribute => {
                                if (attribute.name === action.payload.attributeName) {
                                    attribute.picklist = action.payload.picklist;
                                }
                                return attribute;
                            })
                            :
                            state.selectedEntity.attributes
                }
            };
        case Events.ATTRIBUTE_TYPE_CHANGED:
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributes: entity.attributes.map((attribute, index) => {
                                if (index === action.payload.index) {
                                    return {
                                        ...attribute,
                                        type: action.payload.type,
                                        picklist: attribute.picklist ? attribute.picklist : ["Value 1"]
                                    }
                                }
                                return attribute;
                            })
                        }
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributes:
                        state.selectedEntity.name === action.payload.entityName ?
                            state.selectedEntity.attributes.map((attribute, index) => {
                                if (index === action.payload.index) {
                                    return {
                                        ...attribute,
                                        type: action.payload.type,
                                        picklist: attribute.picklist ? attribute.picklist : ["Value 1"]
                                    }
                                }
                                return attribute;
                            })
                            :
                            state.selectedEntity.attributes
                }
            }
        case Events.UPDATE_PREVIOUS_SELECTED_ENTITY_NAME:
            debugger;
            return {
                ...state,
                previousNamesOfSelectedEntities: state.namesOfSelectedEntities
            }
        case Events.TOGGLE_SELECT_ALL_ATTRIBUTES: {
            const everyAttributeSelected = state.selectedEntity.attributes.every(attribute => attribute.selected);
            const namesOfSelectedEntities = state.namesOfSelectedEntities.includes(state.selectedEntity.name) ? state.namesOfSelectedEntities : [
                ...state.namesOfSelectedEntities,
                state.selectedEntity.name
            ];
            const isNamesOfSelectedEntitiesChanged = namesOfSelectedEntities.length !== state.namesOfSelectedEntities.length || !namesOfSelectedEntities.every(name => state.namesOfSelectedEntities.includes(name));
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributes: entity.attributes.map(attribute => ({
                                ...attribute,
                                selected: attribute.isAzureAttribute ? true : !everyAttributeSelected
                            })),
                            checked: entity.isStatic ? true : !everyAttributeSelected
                        }
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    checked: state.selectedEntity.isStatic ? true : !everyAttributeSelected,
                    attributes:
                        state.selectedEntity.name === action.payload.entityName ?
                            state.selectedEntity.attributes.map(attribute => ({
                                ...attribute,
                                selected: attribute.isAzureAttribute ? true : !everyAttributeSelected
                            }))
                            :
                            state.selectedEntity.attributes
                },
                namesOfSelectedEntities: namesOfSelectedEntities,
                // relations: isNamesOfSelectedEntitiesChanged ? [] : state.relations,
                // relationsLoaded: isNamesOfSelectedEntitiesChanged ? false : state.relationsLoaded,
                // initialAttributesLoaded: isNamesOfSelectedEntitiesChanged ? false : state.initialAttributesLoaded
            };
        }
        case Events.ENTITY_ATTRIBUTES_LOAD_FAILED:
            const newSelectedEntity = { ...state.selectedEntity };
            if (newSelectedEntity.name === action.payload.entityName) {
                newSelectedEntity.attributes = [];
                newSelectedEntity.attributesLoading = false;
                newSelectedEntity.hasAttributeLoadingError = true;
            }
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributes: [],
                            attributesLoading: false,
                            hasAttributeLoadingError: true
                        };
                    }
                    return entity;
                }),
                selectedEntity: newSelectedEntity
            }
        case Events.ENTITY_ATTRIBUTE_LOADING_STARTED:
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributesLoading: true,
                            hasAttributeLoadingError: false
                        };
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributesLoading: true,
                    hasAttributeLoadingError: false
                }
            };
        case Events.TOGGLE_EDIT_ATTRIBUTE:
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributes: entity.attributes.map((attribute, index) => {
                                if (index === action.payload.attributeIndex) {
                                    return {
                                        ...attribute,
                                        inEdit: !attribute.inEdit
                                    }
                                }
                                return attribute;
                            })
                        }
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributes:
                        state.selectedEntity.name === action.payload.entityName ?
                            state.selectedEntity.attributes.map((attribute, index) => {
                                if (index === action.payload.attributeIndex) {
                                    return {
                                        ...attribute,
                                        inEdit: !attribute.inEdit
                                    }
                                }
                                return attribute;
                            })
                            :
                            state.selectedEntity.attributes
                }
            }
        case Events.ATTRIBUTE_NAME_CHANGED:
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity.name === action.payload.entityName) {
                        return {
                            ...entity,
                            attributes: entity.attributes.map((attribute, index) => {
                                if (index === action.payload.attributeIndex) {
                                    return {
                                        ...attribute,
                                        name: action.payload.newAttributeName
                                    }
                                }
                                return attribute;
                            })
                        }
                    }
                    return entity;
                }),
                selectedEntity: {
                    ...state.selectedEntity,
                    attributes:
                        state.selectedEntity.name === action.payload.entityName ?
                            state.selectedEntity.attributes.map((attribute, index) => {
                                if (index === action.payload.attributeIndex) {
                                    return {
                                        ...attribute,
                                        name: action.payload.newAttributeName
                                    }
                                }
                                return attribute;
                            })
                            :
                            state.selectedEntity.attributes
                }
            }
        case Events.TOGGLE_SELECT_ALL_RELATIONS:
            const everyRelationSelected = state.relations.every(relation => relation.selected);
            return {
                ...state,
                relations: state.relations.map(relation => ({
                    ...relation,
                    selected: !everyRelationSelected,
                    showReferenceAttribute: everyRelationSelected ? false : relation.showReferenceAttribute
                }))
            };
        case Events.CARDINALITY_CHANGED:
            return {
                ...state,
                relations: state.relations.map((relation, relationIndex) => {
                    if (relationIndex === action.payload.relationIndex) {
                        return {
                            ...relation,
                            cardinality: action.payload.cardinality.value,
                            showReferenceAttribute: action.payload.cardinality.value === "1-*" ? relation.showReferenceAttribute : false,
                            referenceAttribute: action.payload.cardinality.value === "1-*" ? relation.referenceAttribute : ""
                        }
                    }
                    return relation;
                })
            };
        case Events.FACED_ERROR:
            return {
                ...state,
                error: action.payload.error
            };
        case Events.RELATION_SWAP: {
            return {
                ...state,
                relations: state.relations.map((relation, index) => {
                    if (index === action.payload.relationIndex) {
                        return {
                            ...relation,
                            from: relation.to,
                            to: relation.from,
                            showReferenceAttribute: false,
                            referenceAttribute: null
                        }
                    }

                    return relation;
                })
            }
        }
        case Events.DISPLAY_CHECKBOX_TOGGLED: {
            return {
                ...state,
                entities: state.entities.map((entity) => {
                    if (entity.name === action.payload.entityName) {
                        const newPageConfiguration = {
                            ...entity.pageConfiguration,
                            [action.payload.name]: !entity.pageConfiguration[action.payload.name]
                        };
                        const isAnyPageSelected = enabledPageConfigurationFields.some(value => newPageConfiguration[value]);
                        newPageConfiguration.shouldCreateDetailsView = isAnyPageSelected;
                        newPageConfiguration.shouldCreateEditRecord = isAnyPageSelected;
                        newPageConfiguration.shouldCreateNewRecord = isAnyPageSelected;
                        if (isAnyPageSelected) {
                            const selectedPageConfigurationFields = enabledPageConfigurationFields.filter(field => newPageConfiguration[field]);
                            newPageConfiguration.isTableDisabled = selectedPageConfigurationFields.length === 1 && selectedPageConfigurationFields[0] === "shouldCreateTable";
                        } else {
                            newPageConfiguration.isTableDisabled = true;
                            newPageConfiguration.shouldCreateTable = true;
                            newPageConfiguration.shouldCreateDetailsView = true;
                            newPageConfiguration.shouldCreateEditRecord = true;
                            newPageConfiguration.shouldCreateNewRecord = true;
                        }
                        return {
                            ...entity,
                            pageConfiguration: newPageConfiguration
                        }
                    }
                    return entity;
                })
            }
        }
        case Events.TOGGLE_DISPLAY_CONFIGURATION_LOADED: {
            return {
                ...state,
                isPageConfigurationLoading: !state.isPageConfigurationLoading
            }
        }
        case Events.TOGGLE_LOAD_EDIT_PAGE_CONFIGURATION:
            return {
                ...state,
                // the following boolean is added so we do not have to
                // load the configurations again when the user navigates back
                // it is set to true only when in relation recommendation,
                // entities change is detected.
                shouldLoadEditPageConfigurations: !state.shouldLoadEditPageConfigurations
            }
        default:
            return state;
    }
}